import Vue from "vue"
Vue.mixin({

	// 格式化金额,每隔三位加逗号
	filters: {
		$phoneFilter (value) {
		   let reg=/^(.{3}).*(.{4})$/;
		   return value.replace(reg,'$1****$2');
		  },
	    $numFilter (value) {
		    let realVal = ''
		    if (!isNaN(value) && value!== '') {
		      // 截取当前数据到小数点后两位
		      realVal = parseFloat(value).toFixed(2)
		    } else {
		      realVal = '--'
		    }
		    return realVal
		  },
		  $numFilter2 (value) {
		      let realVal = ''
		      if (!isNaN(value) && value!== '') {
		        // 截取当前数据到小数点后两位
		        realVal = parseFloat(value).toFixed(0)
		      } else {
		        realVal = '--'
		      }
		      return realVal
		    },
		$defaultValue(str, defaultValue) {
			defaultValue = defaultValue ? defaultValue : '--'
			return str ? str : defaultValue
		},

		$moneyDefaultValue(str) {
			let defaultValue = '0.00'
			return str ? str : defaultValue
		},

		$blankDefaultValue(str) {
			let defaultValue = '--'
			return str ? str : defaultValue
		},

		$dateFormat(date) {
			if (!date) {
				return ''
			}
			date = new Date(date);
			let y = date.getFullYear();
			let m = date.getMonth() + 1;
			let d = date.getDate();
			let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			let i = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
			//var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
			m = m < 10 ? "0" + m : m; //月份如果小于10，则在前面加一个0
			d = d < 10 ? "0" + d : d; //day如果小于10，则在前面加一个0
			let time = y + "-" + m + "-" + d + " " + h + ":" + i;
			return time.replace(/\-/g, "/");
		},

		$dayDateFormat(date) {
			if (!date) {
				return ''
			}
			date = new Date(date);
			let y = date.getFullYear();
			let m = date.getMonth() + 1;
			let d = date.getDate();
			let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			let i = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
			//var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
			m = m < 10 ? "0" + m : m; //月份如果小于10，则在前面加一个0
			d = d < 10 ? "0" + d : d; //day如果小于10，则在前面加一个0
			return y + "-" + m + "-" + d;
		},

		$moneyFormat(money) {
			if (money && money != null) {
				money = String(money);
				let left = money.split('.')[0],
					right = money.split('.')[1];
				right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
				// var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
				let temp = left.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ',');
				// return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
				// return (Number(money) < 0 ? '-' : '') + temp + right;
				return  temp + right;
			} else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
				return '0.00';
			} else{
				return '--';
			}
		}
	},
	methods: {
		/** 格式化带时分秒的时间 */
		$formatDateTime(date) {
			var date = new Date(date);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			var d = date.getDate();
			var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			var i = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
			var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
			m = m < 10 ? "0" + m : m; //月份如果小于10，则在前面加一个0
			d = d < 10 ? "0" + d : d; //day如果小于10，则在前面加一个0
			return y + "-" + m + "-" + d + " " + h + ":" + i + ":" + s;
		},

		/** 时间带年月日格式化 */
		$formatDate(date) {
			if (!date) {
				return ''
			}
			var date = new Date(date);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			var d = date.getDate();
			m = m < 10 ? "0" + m : m; //月份如果小于10，则在前面加一个0
			d = d < 10 ? "0" + d : d; //day如果小于10，则在前面加一个0
			return y + "-" + m + "-" + d;
		},

		/**
		 * 根据给定日期返回该月份的起始结束时间
		 * offset: 给定时间的月偏移量
		 * 返回格式： 2019-12-06 09:20:21
		 */
		$getMonthStartAndEndTimeByDate(date, offset = 0) {
			let dateRange = []
			let currentDate = date
			let month = currentDate.getMonth() + offset
			if (month < 0) {
				let n = parseInt((-month) / 12)
				month += n * 12
				currentDate.setFullYear(currentDate.getFullYear() - n)
			}
			currentDate = new Date(currentDate.setMonth(month))
			// 获得当前月份 0-11
			let currentMonth = currentDate.getMonth()
			// 获得当前年份4位年
			let currentYear = currentDate.getFullYear()
			// 获得上一个月的第一天
			let currentMonthFirstDay = new Date(currentYear, currentMonth, 1)
			// 获得上一月的最后一天
			let currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0).setHours(23, 59, 59)
			currentMonthLastDay = new Date(currentMonthLastDay)
			dateRange.push(currentMonthFirstDay) // 起始日期
			dateRange.push(currentMonthLastDay) // 结束日期
			return dateRange
		},

		/**
		 * 返回两个日期的天数差
		 * @param startDate
		 * @param endDate
		 * @returns {number}
		 */
		$getDayDiff(startDate, endDate) {
			let dt1 = Date.parse(startDate)
			let dt2 = Date.parse(endDate)
			let diff = dt2 - dt1
			return Math.floor(diff / (24 * 3600 * 1000)) +1
		},

		/**
		 * 返回耗时时间
		 * @param startDate
		 * @param endDate
		 * @returns {number}
		 */
		$getTakingTime(dateBegin, endDate) {
			dateBegin = new Date(dateBegin)
			endDate = endDate ? new Date(endDate) : new Date()
			//如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
			var dateEnd = new Date(); //获取当前时间
			var dateDiff = dateEnd.getTime() - dateBegin; //时间差的毫秒数
			var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
			var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
			var hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
			//计算相差分钟数
			var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
			var minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
			//计算相差秒数
			var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
			var seconds = Math.round(leave3 / 1000)
			var leave4 = leave3 % (60 * 1000) //计算分钟数后剩余的毫秒数
			var minseconds = Math.round(leave4 / 1000)
			var str = ''
			if (dayDiff > 0) {
				str += dayDiff + " 天 ";
			}
			if (str || hours > 0) {
				str += hours + ' 小时 '
			}

			if (str || minutes > 0) {
				str += minutes + ' 分钟 '
			}
			// var timeFn = dayDiff+" 天 "+hours+" 小时 "+minutes+" 分钟"+seconds+" 秒";
			return str;
		},

		$getDay(day) {
			var today = new Date();
			var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
			today.setTime(targetday_milliseconds); //注意，这行是关键代码

			var tYear = today.getFullYear();
			var tMonth = today.getMonth();
			var tDate = today.getDate();
			tMonth = this.$doHandleMonth(tMonth + 1);
			tDate = this.$doHandleMonth(tDate);
			return tYear + "-" + tMonth + "-" + tDate;
		},
		$doHandleMonth(month) {
			var m = month;
			if (month.toString().length == 1) {
				m = "0" + month;
			}
			return m;
		},
	

	}
})



// WEBPACK FOOTER //
// ./src/mixin/format.js